import React from 'react';

import Icon from '../Icon/Icon';

const VeevAboutBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props} fill='none'>
            <path
                d='M12.75 7.67765C12.75 6.75111 13.5011 6 14.4276 6H26.6544C27.581 6 28.3321 6.75111 28.3321 7.67765V39.9724C28.3321 40.8989 27.581 41.65 26.6544 41.65H14.4276C13.5011 41.65 12.75 40.8989 12.75 39.9724V7.67765Z'
                fill='#393E44'
            />
            <path
                d='M30.5996 10.2943C30.5996 10.0627 30.7874 9.87488 31.019 9.87488H34.8302C35.0618 9.87488 35.2496 10.0627 35.2496 10.2943V36.6328L34.892 41.2628C34.8751 41.4812 34.6929 41.6499 34.4738 41.6499H31.3754C31.1563 41.6499 30.9741 41.4812 30.9572 41.2628L30.5996 36.6328V10.2943Z'
                fill='#393E44'
            />
            <path
                d='M31.375 19.9499C31.375 19.0939 32.069 18.3999 32.925 18.3999C33.781 18.3999 34.475 19.0939 34.475 19.9499V21.4999C34.475 22.3559 33.781 23.0499 32.925 23.0499C32.069 23.0499 31.375 22.3559 31.375 21.4999V19.9499Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32.9258 19.2001C33.34 19.2001 33.6758 19.5359 33.6758 19.9501V21.5001C33.6758 21.9143 33.34 22.2501 32.9258 22.2501C32.5116 22.2501 32.1758 21.9143 32.1758 21.5001V19.9501C32.1758 19.5359 32.5116 19.2001 32.9258 19.2001Z'
                fill='#FFFDFB'
            />
            <path
                d='M28.3255 7.53479H17.0073C16.465 7.53479 16.0254 7.97441 16.0254 8.5167V39.1338C16.0254 39.6761 16.465 40.1157 17.0073 40.1157H28.3255C28.3295 40.0684 28.3315 40.0206 28.3315 39.9724V38.9907H17.1504V8.65979H28.3315V7.67765C28.3315 7.62953 28.3295 7.58188 28.3255 7.53479Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default VeevAboutBlueIcon;
